import { Cohort } from 'nove8/constants/root-constants'
import { getRemoteConfigVariantData } from 'nove8/helpers/getRemoteConfigVariantData'
import { FirebaseRemoteConfigKey, TestGroup, LOCALES } from 'root-constants'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const isWoofyChatUpsellAfterAccountEnabled = (): boolean => {
  const {
    firebaseRemoteConfig,
    lead,
    initialCohort,
  } = useZustandStore.getState()
  const cohort = lead?.cohort || initialCohort
  const langFromUrl = new URL(window.location.href).searchParams.get('lang')
  const language = langFromUrl || useZustandSessionStore.getState().language

  if (cohort !== Cohort.WOOFZ_PPP_WOOFY || language !== LOCALES.EN) {
    return false
  }

  const segment = getRemoteConfigVariantData({
    firebaseRemoteConfig,
    firebaseRemoteConfigKey:
      FirebaseRemoteConfigKey.ABTEST_WEB_2592_WOOFY_CHAT_UPSELL,
  })

  return segment?.toString() === TestGroup.ABTEST_WEB_2592_B_AFTER_ACCOUNT
}
